
import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p372291134221672448',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})

